import { Table, TableProps } from 'antd';
import React from 'react';
import { JobDTO } from 'types/types';

interface JobsCompareProps {
  jobs: JobDTO[];
}

interface DataType {
  key: string;
  property: string;
  job1: string | number | undefined;
  job2: string | number | undefined;
}

const columns: TableProps<DataType>['columns'] = [
  {
    title: 'Property',
    dataIndex: 'property',
    key: 'property',
  },
  {
    title: 'Job 1',
    dataIndex: 'job1',
    key: 'job1',
  },
  {
    title: 'Job 2',
    dataIndex: 'job2',
    key: 'job2',
  },
];

const InformationTab: React.FC<JobsCompareProps> = ({ jobs }) => {
  const [job1, job2] = jobs;

  const data: DataType[] = [
    {
      key: '1',
      property: 'Spark Job ID',
      job1: job1.sparkJobId,
      job2: job2.sparkJobId,
    },
    {
      key: '2',
      property: 'Schema Name',
      job1: job1.schemaName,
      job2: job2.schemaName,
    },
    {
      key: '3',
      property: 'Table Name',
      job1: job1.tableName,
      job2: job2.tableName,
    },
    {
      key: '5',
      property: 'MV Language',
      job1: job1.mvLanguage,
      job2: job2.mvLanguage,
    },
    {
      key: '6',
      property: 'Spark Job Status',
      job1: job1.sparkJobStatus,
      job2: job2.sparkJobStatus,
    },
    {
      key: '7',
      property: 'Total Executor Count',
      job1:
        job1.totalExecutorCount !== undefined && job1.totalExecutorCount > 0
          ? job1.totalExecutorCount
          : 'Executor not found',
      job2:
        job2.totalExecutorCount !== undefined && job2.totalExecutorCount > 0
          ? job2.totalExecutorCount
          : 'Executor not found',
    },
    {
      key: '9',
      property: 'Enter Queue',
      job1: job1.queueingTime > 0 ? 'Yes' : 'No',
      job2: job2.queueingTime > 0 ? 'Yes' : 'No',
    },
  ];

  return <Table columns={columns} dataSource={data} pagination={false} />;
};

export default InformationTab;
